import {saleScheduled} from '@wix/wix-events-commons-statics'
import {isChooseMultipleSeatsMode, isChooseSeatMode} from '../../../../../selectors/navigation'
import {getSelectedPlaceId} from '../../../../../selectors/seating/mode'
import {getSelectedPlaceQuantity} from '../../../../../selectors/seating/place'
import {DetailsPageAppProps} from '../../../../app/interfaces'
import {connect} from '../../../../runtime-context/context'
import {TicketActionOwnProps, TicketActionRuntimeProps} from './interfaces'
import {TicketAction as Presentation} from './ticket-action'

const mapRuntime = (
  {state, actions: {setPlaceQuantity, selectPlacePricingOption, updatePlace}}: DetailsPageAppProps,
  {place}: TicketActionOwnProps,
): TicketActionRuntimeProps => {
  const ticket = place?.ticket

  return {
    selectedTicketQuantity: getSelectedPlaceQuantity(state, ticket?.id, place?.id),
    chooseSeatMode: isChooseSeatMode(state),
    chooseMultipleSeatsMode: isChooseMultipleSeatsMode(state),
    setPlaceQuantity,
    selectPlacePricingOption,
    updatePlace,
    scheduled: ticket ? saleScheduled(ticket) : undefined,
    description: ticket.description,
    isPlaceSelected: getSelectedPlaceId(state) === place.id,
  }
}

export const TicketAction = connect<TicketActionOwnProps, TicketActionRuntimeProps>(mapRuntime)(Presentation)
export * from './interfaces'
